/**
 * Room-type registry. Every space in the palace — galleries, connectors, the
 * rotunda — is a type module conforming to docs/palace-room-types.md.
 *
 * NOTE for room-type authors: do not edit this file; new types are registered
 * here by the integrator after review.
 */

import gallery from './gallery';
import grandHall from './grandHall';
import cabinet from './cabinet';
import corridor from './corridor';
import rotunda from './rotunda';
import tribuna from './tribuna';
import peristyle from './peristyle';
import exedra from './exedra';
import courtOfLions from './courtOfLions';
import qubba from './qubba';
import iwan from './iwan';
import hypostyle from './hypostyle';
import pavilion from './pavilion';
import moonGate from './moonGate';

const ALL = [
  gallery, grandHall, cabinet, exedra, qubba, iwan, hypostyle, pavilion,
  corridor, tribuna, peristyle, courtOfLions, moonGate,
  rotunda,
];

export const ROOM_TYPES = Object.fromEntries(ALL.map((t) => [t.id, t]));

export const typesForRole = (role) => ALL.filter((t) => t.role === role);
